<div class="left-menu"
  [ngClass]="{'side-menu-collapse': !sideMenuExpanded}">
  <div class="menu-image">
    @if (orgLogoUrl) {
      <img alt="org-logo"
        [src]="orgLogoUrl"
        (error)="avatar='';"
        (load)="orgImageLoading=false"
        />
    } @else {
      @if (orgName) {
        <label for=""
        class="org-name">{{orgName}}</label>
      }
    }
    <ng-template #name>
      @if (orgName) {
        <label for=""
        class="org-name">{{orgName}}</label>
      }
    </ng-template>
    <chq-custom-loader [showLoading]="orgImageLoading"></chq-custom-loader>
  </div>
  <div class="menu-item-wrapper">
    @for (item of menuItems; track item) {
      @if (item.permission) {
        <div class="menu-item"
          [ngClass]="{'active': item.name === currentParent}"
          >
          <div class="item-wrapper">
            <div class="text-icon"
              (click)="navigate(item)"
              [ngClass]="{'hasActiveChild': (item.name === currentParent) && (item.childMenu && item.childMenu.length > 0)}">
              <mat-icon [svgIcon]="item.icon"
                color="white"
              aria-hidden="false"></mat-icon>
              <div class="item-text">
                <span>{{item.name | translate}}</span>
              </div>
            </div>
            @if ((item.name === currentParent) && (item.childMenu && item.childMenu.length > 0)) {
              <div
                class="child-menu-wrapper">
                @for (child of item.childMenu; track child) {
                  @if (child.permission) {
                    @if ((!child.childMenu || child.childMenu.length === 0) || (!isGrandChildActive(child) && child.name !== currentChild)) {
                      <div
                        class="child-menu-item"
                        [ngClass]="{'active': (child.name === currentChild)}"
                        (click)="navigate(child)">
                        <span>{{child.name | translate}}</span>
                      </div>
                    } @else {
                      <div class="nested-menu-wrapper">
                        <span class="nested-menu-title">{{child.name | translate}}</span>
                        @for (gchild of child.childMenu; track gchild) {
                          @if (gchild.permission) {
                            <div
                              class="grand-child-menu-item"
                              [ngClass]="{'active': (gchild.name === currentChild)}"
                              (click)="navigate(gchild)">
                              <span>{{gchild.name | translate}}</span>
                            </div>
                          }
                        }
                      </div>
                    }
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</div>

@if (sideMenuExpanded && showBackdrop) {
  <div class="backdrop"
  (click)="collapseSideMenu()"></div>
}

@if (agentAssociationId) {
  <div
    [hidden]="showAIAssistant"
    class="ai-agent-assistant-wrapper"
    (click)="hideShowAIAssistant()"
    (keypress)="hideShowAIAssistant()">
    <!-- <img class="ai-background"
    src="assets/img/ai/ai-background.gif"
    alt="frame" /> -->
    <img class="ai-profile"
      [src]="avatarUrl"
      alt="frame" />
    </div>
  }


  @if (aiApiLoaded && agentAssociationId) {
    <ai-agent-assistant
      [hidden]="!showAIAssistant"
      [floating]="true"
      [agentAssociationId]="agentAssociationId"
      [orgId]="selectedOrgId"
      [userDetail]="userDetail"
    (closed)="hideShowAIAssistant()"></ai-agent-assistant>
  }